import { Typography } from '@mui/material'
import { ColStack } from 'components/atoms/container/InCardStack'
import colors from 'styles/colors'

const LeftPanelTitle = ({ title, superText, subText, isLightText = false }) => {
  return (
    <ColStack spacing={4}>
      {superText ? (
        <Typography
          variant='h6'
          color={isLightText ? colors.MutedTeal200 : 'textSecondary'}
          fontWeight={700}
          textTransform='uppercase'>
          {superText}
        </Typography>
      ) : null}
      {title ? (
        <Typography variant='h1' color={isLightText ? colors.White : 'primary'}>
          {title}
        </Typography>
      ) : null}
      {subText ? (
        <Typography
          variant='body1Large'
          color={isLightText ? colors.MutedTeal200 : 'primary'}>
          {subText}
        </Typography>
      ) : null}
    </ColStack>
  )
}

export default LeftPanelTitle
